(function () {
  var threshold = document.getElementById('threshold');
  var enterBtn  = document.getElementById('enterBtn');
  var body = document.body;

  // Lock scrolling behind the doors on load
  if (threshold && enterBtn) { body.classList.add('is-locked'); }

  function enter() {
    if (!threshold) return;
    threshold.classList.add('is-open');
    body.classList.remove('is-locked');
    body.classList.add('entered');
    setTimeout(function () { if (threshold) threshold.style.display = 'none'; }, 1900);
    revealObserve();
    document.querySelectorAll('.lineage .reveal').forEach(function (el) { el.classList.add('in'); });
  }
  if (enterBtn) enterBtn.addEventListener('click', enter);

  // Scroll-reveal
  var io;
  function revealObserve() {
    if (io) return;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  }

  // Email capture (demo; wires to Klaviyo on the live store)
  var form = document.getElementById('joinForm');
  var msg  = document.getElementById('formMsg');
  if (form) form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    var val = document.getElementById('email').value.trim();
    var ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
    if (!ok) { msg.textContent = 'A valid email, if you would.'; return; }
    form.style.display = 'none';
    msg.textContent = 'You are within the Circle. Watch for the first light.';
  });

  // Navbar: dark at the top, cream once the visitor scrolls
  var topbar = document.querySelector('.topbar');
  if (topbar) {
    var onScroll = function () {
      if (window.scrollY > 80) { topbar.classList.add('is-scrolled'); }
      else { topbar.classList.remove('is-scrolled'); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();